/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function CompareProductSplit(
    id,
    idParent,
    idProduct,
    productName,
    totalLoanAmount,
    loanTerm,
    interestRate,
    revertRate,
    comparisonRate,
    absLendingPurposeCode,
    fixedTerm,
    interestOnlyTerm,
    repayment1,
    repayment1Info,
    repayment2,
    repayment2Info,
    repayment3,
    repayment3Info,
    principalBalances,
    principalOffsetBalances,
    maximumBorrowing,
    commissions
  ) {
    this.id = id;
    this.idParent = idParent;
    this.idProduct = idProduct;
    this.productName = productName;
    this.totalLoanAmount = totalLoanAmount;
    this.loanTerm = loanTerm;
    this.interestRate = interestRate;
    this.revertRate = revertRate;
    this.comparisonRate = comparisonRate;
    this.absLendingPurposeCode = absLendingPurposeCode;
    this.fixedTerm = fixedTerm;
    this.interestOnlyTerm = interestOnlyTerm;
    this.repayment1 = repayment1;
    this.repayment1Info = repayment1Info;
    this.repayment2 = repayment2;
    this.repayment2Info = repayment2Info;
    this.repayment3 = repayment3;
    this.repayment3Info = repayment3Info;
    this.principalBalances = principalBalances;
    this.principalOffsetBalances = principalOffsetBalances;
    this.maximumBorrowing = maximumBorrowing;
    this.commissions = commissions;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  CompareProductSplit.Blank = function () {
    return CompareProductSplit.Build({
      id: _.uuid(),
      idParent: '',
      idProduct: '',
      productName: '',
      totalLoanAmount: 0,
      loanTerm: 0,
      interestRate: 0,
      revertRate: 0,
      comparisonRate: 0,
      fixedTerm: 0,
      absLendingPurposeCode: {
        id: '',
        value: ''
      },
      interestOnlyTerm: 0,
      repayment1: 0,
      repayment1Info: '',
      repayment2: 0,
      repayment2Info: '',
      repayment3: 0,
      repayment3Info: '',
      principalBalances: [],
      principalOffsetBalances: [],
      maximumBorrowing: 0,
      commissions: {
        loanAccountNumber: '',
        offsetAccountNumber: ''
      }
    });
  };
  CompareProductSplit.Build = function (data) {
    return new CompareProductSplit(
      data.id ? data.id : _.uuid(),
      data.idParent ? data.idParent : '',
      data.idProduct ? data.idProduct : '',
      data.productName ? data.productName : '',
      data.totalLoanAmount ? data.totalLoanAmount : 0,
      data.loanTerm ? data.loanTerm : 0,
      data.interestRate ? data.interestRate : 0,
      data.revertRate ? data.revertRate : 0,
      data.comparisonRate ? data.comparisonRate : 0,
      !_.isEmpty(data.absLendingPurposeCode)
        ? data.absLendingPurposeCode
        : {
            id: '',
            value: ''
          },
      data.fixedTerm ? data.fixedTerm : 0,
      data.interestOnlyTerm ? data.interestOnlyTerm : 0,
      data.repayment1 ? data.repayment1 : 0,
      data.repayment1Info ? data.repayment1Info : 0,
      data.repayment2 ? data.repayment2 : 0,
      data.repayment2Info ? data.repayment2Info : 0,
      data.repayment3 ? data.repayment3 : 0,
      data.repayment3Info ? data.repayment3Info : 0,
      data.principalBalances ? data.principalBalances : [],
      data.principalOffsetBalances ? data.principalOffsetBalances : [],
      data.maximumBorrowing ? data.maximumBorrowing : 0,
      data.commissions
        ? data.commissions
        : {
            loanAccountNumber: '',
            offsetAccountNumber: ''
          }
    );
  };

  return CompareProductSplit;
};
